import { render, staticRenderFns } from "./IconWhatsapp.vue?vue&type=template&id=03c71b94&"
import script from "./IconWhatsapp.vue?vue&type=script&lang=ts&"
export * from "./IconWhatsapp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports